module.exports = __webpack_public_path__ + "static/home-page-75a8a2a6546cf60088721f8744b8f563.mp4";